import { SimpleGrid } from "@chakra-ui/react";
import * as React from "react";
import ProgressStatCardSkeleton, {
  ProgressStatCardSkeletonProps,
} from "../../progress-stat-card/src/progress-bar-skeleton";
import {
  CollapsibleStatSectionWrapperProps,
  CollapsibleStatsSectionWrapper,
} from "./collapsible-stats-section-wrapper";

export interface CollapsibleStatSectionSkeletonProps
  extends Omit<CollapsibleStatSectionWrapperProps, "children"> {
  title: string;
  subtitle: React.ReactNode;
  numberOfStats?: number;
  cardProps?: ProgressStatCardSkeletonProps;
  colorScheme?: string;
}
export const CollapsibleStatSectionSkeleton: React.FC<
  CollapsibleStatSectionSkeletonProps
> = ({
  numberOfStats,
  title,
  subtitle,
  colorScheme,
  knowledgeCenterSlug,
  cardProps,
}) => {
  return (
    <CollapsibleStatsSectionWrapper
      {...{ title, subtitle, colorScheme, knowledgeCenterSlug }}
    >
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="6">
        {Array.from(Array(numberOfStats).keys()).map((_a, i) => (
          <ProgressStatCardSkeleton
            key={title + "-" + i}
            color={colorScheme + ".500"}
            h="173px"
            {...cardProps}
          />
        ))}
      </SimpleGrid>
    </CollapsibleStatsSectionWrapper>
  );
};
